<template>
  <RegisterForm
    :title="$t('verificationStatus.poaVerification.poaInformation.stepTitle')"
    :nextButtonOnClick="nextButtonOnClick"
    verticalPadding="py-0"
  >
    <div class="mt-2">
      <PoaInformationComponent
        ref="form"
        radioLabel="verificationStatus.poaVerification.poaInformation.title"
        radioTypeInfoText="verificationStatus.poaVerification.poaInformation.radioTypeInfoText"
        :disabled="isDisabled"
      /></div
  ></RegisterForm>
</template>

<script>
import { mapState } from 'vuex';
import registerStep from '@/constants/register/registerStep';
import auditStatus from '@/constants/auditStatus';
import { RegisterRoutePath } from '@/router/registerRoutes';
import registerRepository from '@/repositories/register/registerRepository';
import PoaInformationComponent from '@/components/register/registerForms/uploadForms/PoaInformation.vue';
import RegisterForm from '@/components/register/registerForms/RegisterForm.vue';
import poaStore from '@/store/register/poaVerification/poaStore';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

export default {
  name: 'PoaInformation',
  components: { PoaInformationComponent, RegisterForm },
  data() {
    return {
      // is completed be4
      isCompletedBefore: false
    };
  },
  mounted() {
    if (this.activeTab === registerStep.poaInformation) {
      this.init();
    }
  },
  computed: {
    // Pending record
    poaPendingRecord() {
      return poaStore.state.poaPendingRecord;
    },
    isDisabled() {
      return this.poaAuditStatus === auditStatus.pending || this.isCompletedBefore;
    },
    poaInformationForm() {
      return poaStore.state.poaInformationForm;
    },
    ...mapState('common', ['poiAuditStatus', 'poaAuditStatus']),
    ...mapState('register', ['currStep', 'activeTab'])
  },
  methods: {
    async init() {
      // Pendig record
      if (this.poaAuditStatus === auditStatus.pending) {
        this.$refs.form.form = {
          ...this.$refs.form.form,
          ...this.poaPendingRecord
        };
        poaStore.dispatch('setPoaInformationForm', this.poaPendingRecord);
      } else {
        if (this.poaInformationForm === null) {
          const response = await poaStore.dispatch('actionGetData');
          if (response instanceof Error) {
            this.$message({
              message: response.message,
              type: 'error'
            });
            this.$router.push(RegisterRoutePath.register);
          }
        }
        // Set sub step for Step 5
        // If never submitted and is completed 4.1
        // Use address to determine as suburb may filled in general POI
        if (
          this.currStep === registerStep.poaInformation &&
          // Created from admin portal, this.poiAuditStatus === auditStatus.init
          this.poiAuditStatus !== auditStatus.init &&
          this.poaAuditStatus === auditStatus.init &&
          this.poaInformationForm?.address?.length > 0 &&
          this.poaInformationForm?.suburb?.length > 0
        ) {
          this.$store.dispatch('register/setStep', registerStep.poaUpload);
        }

        // Init form data
        // Only first time filling can edit
        // Use address to determine as suburb may filled in general POI
        this.isCompletedBefore =
          this.poaAuditStatus !== auditStatus.init &&
          this.poaInformationForm?.address?.length > 0 &&
          this.poaInformationForm?.suburb?.length > 0;

        if (this.$refs.form?.form) {
          this.$refs.form.form = {
            ...this.$refs.form.form,
            ...this.poaInformationForm
          };
        }
      }
    },
    nextButtonOnClick() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_CLICK, {
        openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV3,
        openidentity_step: SENSORS_TRACK.IDENTITY_STEP.LV3_POA_INFORMATION,
        button_name: SENSORS_TRACK.BUTTON_NAME.LV3_NEXT
      })
      if (this.isDisabled) {
        this.$store.dispatch('register/setActiveTab', registerStep.poaUpload);
      } else {
        this.$refs.form?.validate(async valid => {
          if (valid) {
            const response = await registerRepository.updateUserIdAddress({
              ...(this.$refs?.form?.form ?? {})
            });

            if (response instanceof Error) {
              this.$message({
                message: response.message,
                type: 'error'
              });
            } else {
              if (this.currStep > registerStep.poaUpload) {
                this.$store.dispatch('register/setActiveTab', registerStep.poaUpload);
              } else {
                this.$store.dispatch('register/setStep', registerStep.poaUpload);
              }
            }
          } else {
            console.log('error submit!!');
          }
        });
      }
    }
  }
};
</script>
